// @packages
import MockAdapter from 'axios-mock-adapter';
import axios from 'axios';

// @scripts
import { config } from '../config';
import { createMockResponse } from '../helpers';

const mockedFunctions = {
    mockProductGetCandidateSvc: (mockAdapter) => {
        const url = config.services.product.getCandidate;

        mockAdapter.onPost(url).reply(() => createMockResponse({
            data: config.mockData.candidateProduct,
            httpCode: 200
        }));
    },
    mockProductGetScheduleSvc: (mockAdapter) => {
        const url = config.services.product.getSchedule;

        mockAdapter.onGet(url).reply(() => createMockResponse({
            data: config.mockData.schedule,
            httpCode: 200
        }));
    }
};

export const initializeServiceMocker = (store) => {
    if (config.settings.serviceMocker.isEnabled) {
        const mockAdapter = new MockAdapter(
            axios, {
                delayResponse: config.settings.serviceMocker.delayResponse
            }
        );

        const serviceMocker = {
            replyWithMockData: () => {
                mockAdapter.reset();
                const exclude = config.settings.serviceMocker.exclude || [];
                Object.keys(mockedFunctions).forEach((name) => {
                    if (!exclude.some((item) => item === name)) {
                        mockedFunctions[name](mockAdapter, store);
                    }
                });
                mockAdapter.onAny().passThrough();
            },
            replyWithNetworkError: () => {
                mockAdapter.reset();
                mockAdapter.onAny().networkError();
            }
        };

        serviceMocker.replyWithMockData();
        return serviceMocker;
    }

    return null;
};
